import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LayoutModule } from "@angular/cdk/layout";
import { CityDetailsComponent } from "./city-details/city-details.component";
import { SharedModule } from "../../shared/shared.module";
import { RouterModule } from "@angular/router";
import { ErrorsComponent } from "./errors/errors.component";
import { TestsComponent } from "./tests/tests.component";
import { DetailsComponent } from "./details.component";
import { SicComponent } from "./tests/sic/sic.component";
import { MaterialModule } from "../../shared/material.module";

@NgModule({
    declarations: [
        DetailsComponent,
        CityDetailsComponent,
        ErrorsComponent,
        TestsComponent,
        SicComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        MaterialModule,
        LayoutModule,
        RouterModule,
    ],
})
export class DetailsModule {}
